import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { UserService } from './services/user.service';
import { AuthService } from './services/auth.service';
import { isPlatformBrowser } from '@angular/common';
import { Subscription, timer } from 'rxjs';
import { User } from './models/user.model';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'cloud-provisioner';
  user:any;
  sub: Subscription | undefined;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private authService: AuthService,
    private userService: UserService,
    private _registry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private msalService: MsalService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      // Wait for MSAL to be ready
      const accounts = this.msalService.instance.getAllAccounts();
      if (accounts.length > 0) {
        // Load user data
        console.log("load user in app component")
        this.userService.loadUser().subscribe({
          next: (user) => {
            console.log('User loaded successfully:', user);
            this.user = user;
          },
          error: (error) => {
            console.error('Error loading user:', error);
          }
        });
      } else {
        console.log('No authenticated user found');
      }
    } catch (error) {
      console.error('Error during initialization:', error);
    }
  
    this.registerIcons();
  }

  private registerIcons() {
    console.log("Registering icons")
    this._registry.addSvgIcon('product-suite-icon', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/product-suite-icon.svg'));
    this._registry.addSvgIcon('maxis-logo', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/Maxis-Logo.svg'));
    this._registry.addSvgIcon('help-circle', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/help-circle.svg'));
    this._registry.addSvgIcon('maxis-logo-no-text', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/maxis-logo-no-text.svg'));
    this._registry.addSvgIcon('user', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/user.svg'));
    this._registry.addSvgIcon('cloud-serve-logo', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/cloud-serve-logo.svg'));
    this._registry.addSvgIcon('circle-check', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/circle-check.svg'));
    this._registry.addSvgIcon('error-pulse', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/error-pulse.svg'));
    this._registry.addSvgIcon('loader', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/loader.svg'));
    this._registry.addSvgIcon('circle-check-green', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/circle-check-green.svg'));
    this._registry.addSvgIcon('info-circle', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/information.svg'));
    this._registry.addSvgIcon('x', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/x.svg'))
    this._registry.addSvgIcon('alert-circle', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/alert-circle.svg'));

  }

}
